import React from "react";
import {FaRegTimesCircle,FaAngleRight} from 'react-icons/fa'

export default function ErrorList(props) {
    
    return (
        <>
        {
            (props.errors != null && props.errors.length > 0) && (
                <div className="rounded-md ... bg-red-100 text-red-600 p-5 ">
                    <div>
                    {props.errors.map(err => (
                        <div className="text-left p-1" key={err}>
                        <span className="inline-block align-middle ..."><FaRegTimesCircle /></span> 
                        <span className="ml-2">{err}</span>
                        </div>
                    ))}      
                    </div>
                </div>
            ) 
        }
        {
            (props.messages != null && props.messages.length > 0) && (
                <div className="rounded-md ... bg-indigo-100 text-indigo-600 p-5 ">
                    <div>
                    {props.messages.map(msg => (
                        <div className="text-left p-2" key={msg}>
                        <span className="inline-block align-middle ..."><FaAngleRight /></span> 
                        <span className="ml-2">{msg}</span>
                        </div>
                    ))}      
                    </div>
                </div>
            )  
        } 
        </>
    );

}